module.exports = __webpack_public_path__ + "img/livepen-content.54917b17.png";